import React, { FC, CSSProperties } from 'react';
import styled from 'styled-components';
import { PaymentMethod } from '../../../types';

const containerStyle: CSSProperties = {
  display: 'flex',
  listStyle: 'none',
};

const itemStyle: CSSProperties = {
  flex: 1,
  padding: '0 10px',
};

const Button = styled.button`
  display: block;
  width: 100%;
  border: none;
  cursor: pointer;
  font: inherit;
  padding: 20px 0;
  border-radius: 4px;
  background: transparent;
  &:hover {
    background: #eee;
    color: #a32563;
    svg {
      fill: #a32563;
    }
  }
`;

const iconStyle: CSSProperties = {
  display: 'block',
  margin: '0 auto 15px',
};

interface Props {
  selectMethod(method: PaymentMethod): void;
}

const ChoosePaymentMethod: FC<Props> = ({ selectMethod }) => {
  return (
    <ul style={containerStyle}>
      <li
        style={{
          ...itemStyle,
          borderRight: '1px solid #eee',
        }}
      >
        <Button
          onClick={(ev) => {
            ev.preventDefault();
            selectMethod('credit');
          }}
        >
          <svg
            style={iconStyle}
            fill="#aaa"
            height="54px"
            viewBox="0 0 512 512"
            enableBackground="new 0 0 512 512"
          >
            <path d="M480,96H32c-17.688,0-32,14.313-32,32v64h512v-64C512,110.313,497.688,96,480,96z" />
            <path d="M0,256v128c0,17.688,14.313,32,32,32h448c17.688,0,32-14.313,32-32V256H0z M160,352H64v-64h96V352z M320,352h-32v-32h32V352z M384,352h-32v-32h32V352z M448,352h-32v-32h32V352z" />
          </svg>
          Crédito
        </Button>
      </li>
      <li style={itemStyle}>
        <Button
          onClick={(ev) => {
            ev.preventDefault();
            selectMethod('boleto');
          }}
        >
          <svg style={iconStyle} fill="#aaa" height="54px" viewBox="0 0 512 512">
            <path d="M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z" />
          </svg>
          Boleto
        </Button>
      </li>
    </ul>
  );
};

export default ChoosePaymentMethod;
